export interface Comic {
  id: string;
  title: string;
  originalTitle: string;
  cover: string;
  category: string;
  tags: string[];
  author: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  likes: number;
  favorites: number;
  year: number;
  description: string;
  featured?: boolean;
}

export const comics: Comic[] = [
  {
    id: 'tent-secret',
    title: '帐篷里的秘密',
    originalTitle: '텐트 속의 비밀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20manhwa%20cover%20illustration%2C%20young%20couple%20sitting%20close%20together%20on%20a%20blanket%20beside%20a%20warm%20glowing%20tent%20at%20a%20lakeside%20campsite%20at%20dusk%2C%20golden%20sunset%20light%20reflecting%20on%20calm%20water%2C%20pine%20forest%20silhouette%2C%20gentle%20heart%20shapes%20floating%20in%20the%20sky%2C%20clean%20pastel%20painting%20style%20with%20warm%20orange%20and%20soft%20pink%20tones%2C%20dreamy%20romantic%20atmosphere%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=tent-secret-cover&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '治愈', '露营', '青梅竹马'],
    author: '朴智恩',
    status: '连载中',
    rating: 9.8,
    views: 120000000,
    likes: 1286000,
    favorites: 963000,
    year: 2024,
    description:
      '内向的都市女生林夏在一次意外中加入了公司组织的露营活动，却发现自己和暗恋多年的同事顾辰被安排在了同一顶帐篷里。狭小的空间里，心跳声清晰可闻……那个看似冷静自持的男人，究竟藏着怎样的秘密？一段从篝火边开始的甜蜜心动，正在徐徐展开。',
    featured: true,
  },
  {
    id: 'gentle-zone',
    title: '温柔禁区',
    originalTitle: '다정한 구역',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20mature%20romance%20manhwa%20cover%2C%20intense%20close-up%20of%20a%20handsome%20man%20in%20a%20soft%20cream%20sweater%20and%20a%20gentle%20woman%2C%20subtle%20warm%20lighting%20with%20floating%20petals%2C%20emotional%20gaze%2C%20refined%20clean%20illustration%20with%20soft%20peach%20and%20warm%20brown%20tones%2C%20tender%20romantic%20atmosphere%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=gentle-zone-cover&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '都市', '温情', '熟龄'],
    author: '李秀妍',
    status: '连载中',
    rating: 9.8,
    views: 110000000,
    likes: 1098000,
    favorites: 812000,
    year: 2024,
    description:
      '外冷内热的建筑设计师沈砚与温柔坚韧的插画师林知夏，在一次次命运般的偶遇中靠近彼此。他们的爱情温柔却坚定，治愈又深刻——直到一段被尘封的往事，成为两人之间不可触碰的温柔禁区。',
  },
  {
    id: 'moonlight-knights',
    title: '月光骑士团',
    originalTitle: '달빛 기사단',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20manhwa%20cover%2C%20noble%20knight%20in%20silver%20armor%20with%20a%20glowing%20sword%20standing%20before%20a%20crescent%20moon%20castle%2C%20ethereal%20moonlight%20and%20floating%20magical%20particles%2C%20dramatic%20fantasy%20illustration%20with%20deep%20indigo%20night%20sky%20and%20warm%20golden%20glow%2C%20epic%20atmosphere%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=moonlight-knights-cover&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '骑士', '热血'],
    author: '金敏书',
    status: '连载中',
    rating: 9.7,
    views: 105000000,
    likes: 978000,
    favorites: 745000,
    year: 2023,
    description:
      '见习骑士黎夜在月圆之夜觉醒了传说中的月光之力，被卷入骑士团与暗影军团千年的宿命对决。剑光所指，月光所至，一场宏大的奇幻冒险就此展开。',
  },
  {
    id: 'first-love',
    title: '初恋的味道',
    originalTitle: '첫사랑의 맛',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20romance%20manhwa%20cover%2C%20a%20shy%20girl%20and%20a%20boy%20with%20a%20candy%20in%20his%20mouth%20standing%20under%20cherry%20blossom%20trees%20in%20a%20sunny%20school%20courtyard%2C%20falling%20pink%20petals%2C%20clean%20bright%20pastel%20illustration%20style%2C%20warm%20afternoon%20lighting%2C%20soft%20focus%20background%20of%20school%20building%2C%20sweet%20youthful%20atmosphere%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=first-love-cover&orientation=portrait',
    category: 'school',
    tags: ['校园', '恋爱', '甜品', '治愈'],
    author: '郑彩恩',
    status: '已完结',
    rating: 9.6,
    views: 98640000,
    likes: 862000,
    favorites: 698000,
    year: 2023,
    description:
      '转学生苏念第一天报到就撞翻了全校闻名的甜品社社长姜砚的招牌蛋糕。为了还债，她被迫成为甜品社的"临时试吃员"，却在一次次甜蜜试吃中，尝到了名为"初恋"的独特味道。',
  },
  {
    id: 'midnight-diner',
    title: '深夜食堂物语',
    originalTitle: '심야식당 이야기',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20food%20slice%20of%20life%20manhwa%20cover%2C%20cozy%20late%20night%20diner%20counter%20with%20steaming%20bowls%20of%20noodles%20and%20dumplings%2C%20warm%20lantern%20light%2C%20a%20smiling%20chef%2C%20intimate%20and%20comforting%20atmosphere%2C%20warm%20amber%20and%20red%20tones%2C%20detailed%20food%20illustration%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=midnight-diner-cover&orientation=portrait',
    category: 'urban',
    tags: ['都市', '治愈', '美食', '温情'],
    author: '崔敏俊',
    status: '连载中',
    rating: 9.7,
    views: 92000000,
    likes: 805000,
    favorites: 623000,
    year: 2022,
    description:
      '只在午夜十二点开门的小小食堂，用一碗热汤治愈每一个深夜归人。漫画以单元剧形式，讲述食客们藏在美食背后的欢笑与泪水。',
  },
  {
    id: 'fog-detective',
    title: '迷雾侦探社',
    originalTitle: '안개 탐정사무소',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20thriller%20manhwa%20cover%2C%20sharp-eyed%20detective%20in%20a%20long%20coat%20holding%20a%20magnifying%20glass%2C%20standing%20in%20foggy%20alley%20with%20a%20single%20warm%20street%20lamp%2C%20mysterious%20atmosphere%20with%20deep%20shadows%20and%20amber%20light%2C%20detailed%20noir%20illustration%20style%2C%20intriguing%20mood%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=fog-detective-cover&orientation=portrait',
    category: 'mystery',
    tags: ['悬疑', '推理', '侦探', '都市'],
    author: '吴世勋',
    status: '连载中',
    rating: 9.6,
    views: 89000000,
    likes: 748000,
    favorites: 571000,
    year: 2023,
    description:
      '警队传奇顾衍之离职后开了一家小小的侦探社，专门接手警方无法破解的"灵异"案件。随着一个个迷雾被拨开，他发现自己追查的每一个案件，都指向同一个惊天秘密。',
  },
  {
    id: 'urban-contract',
    title: '都市契约恋人',
    originalTitle: '계약 연인',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20urban%20romance%20manhwa%20cover%2C%20elegant%20businessman%20and%20confident%20woman%20facing%20each%20other%20on%20a%20rainy%20city%20street%20at%20night%2C%20warm%20glowing%20neon%20reflections%20on%20wet%20pavement%2C%20holding%20a%20business%20contract%2C%20stylish%20modern%20illustration%20with%20deep%20teal%20and%20warm%20amber%20city%20lights%2C%20cinematic%20atmosphere%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=urban-contract-cover&orientation=portrait',
    category: 'urban',
    tags: ['都市', '契约', '恋爱', '商战'],
    author: '韩瑞英',
    status: '连载中',
    rating: 9.5,
    views: 87500000,
    likes: 723000,
    favorites: 546000,
    year: 2024,
    description:
      '为了拯救家族企业，设计师许晚晴与神秘集团继承人陆亦辰签下"三个月契约恋人"协议。谁知假戏真做，两人在这场以利益开局的恋爱里，一步步沦陷真心。',
  },
  {
    id: 'fox-contract',
    title: '妖狐契约',
    originalTitle: '여우 계약',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20romance%20manhwa%20cover%2C%20mysterious%20nine-tailed%20fox%20spirit%20with%20glowing%20golden%20eyes%20and%20a%20young%20shaman%20boy%2C%20surrounded%20by%20floating%20fox%20fire%20spirits%20and%20red%20maple%20leaves%2C%20mystical%20atmosphere%20with%20deep%20teal%20night%20and%20warm%20red%20accents%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=fox-contract-cover&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '恋爱', '妖怪', '契约'],
    author: '罗智雅',
    status: '连载中',
    rating: 9.6,
    views: 84700000,
    likes: 712000,
    favorites: 534000,
    year: 2023,
    description:
      '驱魔师世家的少年云深，在深夜遇见了身受重伤的九尾妖狐白芷。一人一狐以血为契，从此命运相连。人妖殊途，又岂能抵过两心相许？',
  },
  {
    id: 'cloud-lovers',
    title: '云端恋人',
    originalTitle: '구름 연인',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20manhwa%20cover%2C%20couple%20standing%20on%20a%20floating%20island%20above%20the%20clouds%20holding%20hands%2C%20soft%20pink%20and%20lavender%20sky%2C%20small%20glowing%20stars%2C%20gentle%20windblown%20hair%2C%20ethereal%20clean%20pastel%20illustration%2C%20dreamy%20romantic%20atmosphere%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=cloud-lovers-cover&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '奇幻', '异世界', '治愈'],
    author: '姜允儿',
    status: '已完结',
    rating: 9.5,
    views: 83600000,
    likes: 689000,
    favorites: 512000,
    year: 2022,
    description:
      '住在云端城堡里的"天气之神"少女云朵，因为一次失误落入了人间，被温柔的程序员江屿收留。两个世界的人，在云端与人间之间，展开了一场跨越时空的浪漫羁绊。',
  },
  {
    id: 'time-bureau',
    title: '时间管理局',
    originalTitle: '시간관리국',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20sci-fi%20mystery%20manhwa%20cover%2C%20mysterious%20agent%20holding%20a%20glowing%20pocket%20watch%20that%20reveals%20a%20fractured%20clockwork%20city%2C%20swirling%20time%20vortex%2C%20dark%20teal%20and%20warm%20amber%20contrast%2C%20cinematic%20sci-fi%20illustration%2C%20intriguing%20atmosphere%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=time-bureau-cover&orientation=portrait',
    category: 'mystery',
    tags: ['悬疑', '科幻', '时间', '冒险'],
    author: '文泰一',
    status: '连载中',
    rating: 9.5,
    views: 78800000,
    likes: 634000,
    favorites: 468000,
    year: 2024,
    description:
      '神秘组织"时间管理局"专门处理时间线紊乱事件。新晋特工韩晨在追查第一桩案件时发现，所有的时间异常，似乎都源于一场关于他自己的记忆骗局。',
  },
  {
    id: 'super-power-class',
    title: '超能少年班',
    originalTitle: '초능력 반',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20action%20manhwa%20cover%2C%20energetic%20teenage%20boy%20with%20electric%20energy%20glowing%20around%20his%20hands%2C%20school%20uniform%2C%20surrounded%20by%20floating%20embers%20and%20dynamic%20speed%20lines%2C%20bright%20comic%20illustration%20style%2C%20warm%20sunset%20sky%20behind%20modern%20school%20rooftop%2C%20youthful%20heroic%20atmosphere%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=super-class-cover&orientation=portrait',
    category: 'school',
    tags: ['校园', '超能力', '热血', '战斗'],
    author: '赵成宇',
    status: '连载中',
    rating: 9.4,
    views: 76200000,
    likes: 598000,
    favorites: 431000,
    year: 2024,
    description:
      '平静的黎明中学深处，隐藏着一个专门招收超能力少年的特殊班级。普通高中生林小满意外被"录取"，从此开启了一段又燃又欢乐的超能校园生活。',
  },
  {
    id: 'reborn-tycoon',
    title: '重生之最强财阀',
    originalTitle: '환생 재벌',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20urban%20drama%20manhwa%20cover%2C%20young%20CEO%20in%20a%20tailored%20black%20suit%20standing%20in%20front%20of%20a%20gleaming%20city%20skyline%20at%20golden%20hour%2C%20confident%20posture%2C%20floating%20golden%20coins%20and%20rising%20stock%20charts%2C%20sleek%20modern%20illustration%20with%20warm%20orange%20sky%2C%20ambitious%20atmosphere%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=reborn-tycoon-cover&orientation=portrait',
    category: 'urban',
    tags: ['都市', '重生', '逆袭', '商战'],
    author: '申东赫',
    status: '已完结',
    rating: 9.3,
    views: 71000000,
    likes: 567000,
    favorites: 402000,
    year: 2022,
    description:
      '前世含冤而死的商业天才沈辞，重生回到二十岁的大学时代。这一次，他要利用先知先觉的记忆，一步步登上商界之巅，改写自己和家人的命运。',
  },
  {
    id: 'sword-magic',
    title: '剑与魔法物语',
    originalTitle: '검과 마법 이야기',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20adventure%20manhwa%20cover%2C%20adventurous%20heroine%20in%20leather%20armor%20holding%20a%20glowing%20staff%2C%20a%20small%20friendly%20dragon%20beside%20her%2C%20magical%20forest%20with%20giant%20trees%20and%20sparkling%20light%2C%20vibrant%20painterly%20illustration%20with%20warm%20green%20and%20gold%20tones%2C%20adventurous%20atmosphere%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=sword-magic-cover&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '魔法', '萌宠'],
    author: '尹浩民',
    status: '连载中',
    rating: 9.4,
    views: 69800000,
    likes: 543000,
    favorites: 398000,
    year: 2023,
    description:
      '见习魔法师艾莉意外解开了古龙的封印，与一头会说话的小龙结为伙伴。一人一龙踏上寻找传说圣剑的旅途，在剑与魔法的世界里书写属于自己的冒险传说。',
  },
  {
    id: 'passion-basketball',
    title: '逆袭吧热血篮球',
    originalTitle: '농구 열혈',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20sports%20manhwa%20cover%2C%20determined%20basketball%20player%20mid-dunk%20on%20an%20outdoor%20court%20at%20sunset%2C%20sweat%20and%20motion%20sparkles%2C%20dramatic%20orange%20and%20red%20sky%2C%20dynamic%20action%20illustration%2C%20energetic%20youthful%20atmosphere%2C%20vertical%20portrait%20composition%2C%20no%20text&width=400&height=600&seq=basketball-cover&orientation=portrait',
    category: 'school',
    tags: ['校园', '篮球', '热血', '竞技'],
    author: '梁宰源',
    status: '连载中',
    rating: 9.2,
    views: 65400000,
    likes: 498000,
    favorites: 356000,
    year: 2024,
    description:
      '身高不足一米七的高一新生阿哲，怀揣着进入全国大赛的梦想加入篮球社。在天赋与汗水的较量中，他用最倔强的热爱，投出改变命运的一球。',
  },
];

export function getComic(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}